import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, shareReplay, switchMap, tap } from 'rxjs/operators';
import { Country } from 'src/app/models/country';
import { CountryService } from 'src/app/services/country/country.service';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';

@Component({
  selector: 'app-employee-calculator',
  templateUrl: './employee-calculator.component.html',
  styleUrls: ['./employee-calculator.component.scss']
})
export class EmployeeCalculatorComponent implements OnInit {
  public country$: Observable<Country>;
  public isUserCountry$: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    private countryService: CountryService,
    private router: Router,
    private mixpanelService: MixpanelService
  ) {}

  ngOnInit(): void {
    this.country$ = this.route.paramMap.pipe(
      distinctUntilChanged(),
      switchMap((params: ParamMap) =>
        this.countryService.getCountry(params.get('slug'))
      ),
      catchError((_) => {
        this.router.navigate(['404']);
        return of(null);
      }),
      tap((c) => (this.isUserCountry$ = this.countryService.isUserCountry(c))),
      tap((c) =>
        this.mixpanelService.track('Page: Employee Cost Calculator', {
          'GPS Country': c?.name,
        })
      ),
      shareReplay(1)
    );

  }

}
